// Central business information for NAP consistency
export const businessInfo = {
  name: "Apartment Wise",
  description: "Professional apartment and property management services",
  address: {
    streetAddress: "123 Business District",
    addressLocality: "New Delhi",
    addressRegion: "Delhi",
    postalCode: "110001",
    addressCountry: "India"
  },
  phone: "+91 98765 43210",
  email: "contact@apartmentwise.in",
  website: "https://apartmentwise.in",
  
  // Business Hours (in Schema.org format)
  openingHours: [
    "Mo-Fr 09:00-18:00",
    "Sa 09:00-15:00"
  ],
  
  // Social Media Profiles
  socialProfiles: [
    "https://www.facebook.com/apartmentwise",
    "https://www.linkedin.com/company/apartmentwise",
    "https://twitter.com/apartmentwise",
    "https://www.instagram.com/apartmentwise"
  ],
  
  // Services Offered
  services: [
    "Property Management",
    "Maintenance Coordination",
    "Financial Management",
    "Equipment Tracking",
    "Meeting Management",
    "Tax Management",
    "Document Management"
  ],
  
  // Areas Served
  areaServed: [
    "New Delhi",
    "Gurgaon",
    "Noida",
    "Faridabad",
    "Ghaziabad",
    "Greater Noida"
  ],
  
  // Business Details
  foundingDate: "2020-01-01",
  priceRange: "₹₹",
  paymentAccepted: ["Cash", "Credit Card", "Debit Card", "UPI", "Net Banking"],
  
  // Coordinates (for New Delhi)
  coordinates: {
    latitude: 28.6139,
    longitude: 77.2090
  },
  
  // Google Business Profile
  googleBusiness: {
    url: "https://business.google.com/apartmentwise",
    placeId: "ChIJL_P_CXMEDTkRw0ZdG-0GVvw", // Example Place ID
    averageRating: 4.8,
    totalReviews: 127
  },
  
  // Local Statistics
  localStats: {
    propertiesManaged: 250,
    yearsOfService: 4,
    satisfiedClients: 500
  },
  
  // Nearby Landmarks
  nearbyLandmarks: [
    "Connaught Place",
    "India Gate",
    "Red Fort",
    "Lotus Temple",
    "Qutub Minar",
    "Akshardham Temple"
  ]
};

// Local testimonials
export const localTestimonials = [
  {
    name: "Rajesh Kumar",
    location: "Connaught Place, New Delhi",
    text: "Apartment Wise has transformed how we manage our residential complex. Their systematic approach and attention to detail is remarkable.",
    rating: 5
  },
  {
    name: "Priya Sharma",
    location: "Karol Bagh, New Delhi",
    text: "The best property management service in Delhi! They handle everything from maintenance to financial tracking seamlessly.",
    rating: 5
  },
  {
    name: "Amit Gupta",
    location: "Lajpat Nagar, New Delhi",
    text: "Professional, reliable, and efficient. Apartment Wise has made property management stress-free for our society.",
    rating: 4
  }
];

// FAQ for local SEO
export const localFAQs = [
  {
    question: "Do you provide property management services in Delhi NCR?",
    answer: "Yes, we provide comprehensive property management services across Delhi NCR including New Delhi, Gurgaon, Noida, Faridabad, and Ghaziabad."
  },
  {
    question: "What areas in Delhi do you serve?",
    answer: "We serve all major areas in Delhi including Connaught Place, Karol Bagh, Lajpat Nagar, South Delhi, East Delhi, West Delhi, and North Delhi."
  },
  {
    question: "How can I contact Apartment Wise in Delhi?",
    answer: "You can reach us at +91 98765 43210 or email us at contact@apartmentwise.in. Our office is located in the Business District, New Delhi."
  },
  {
    question: "What makes Apartment Wise the best property management company in Delhi?",
    answer: "We offer comprehensive services including maintenance coordination, financial management, equipment tracking, and meeting management, all backed by our local expertise in Delhi's property market."
  }
];